import { cover } from '../../utility/constant/helper.constant'
import { IObserver, Subject } from './subject.class'
import { Model } from '../../classes/model'
import { TTerraceDepth } from '../../utility/type/terraceCover.type'

/**
 * Keeps track of updates regarding the depth of the windows
 */
export class DepthObserver implements IObserver {
  private readonly _subject: Subject
  private _terraceDepth: number = cover.terrace.depth
  private _frontHeight: number = cover.terraceCover.frontHeight()
  private _angleCompensation: number = cover.terraceCover.angleCompensation()
  private _height: number = cover.terraceCover.height
  private _windowsSideTotal: number = cover.terraceCover.windowsSideTotal
  private _windowsSideWidth: number = cover.terraceCover.windowsSideWidth()
  private _logsSideTotal: number = cover.terraceCover.logsSideTotal()

  constructor(subject: Subject) {
    this._subject = subject
    subject.registerObserver(this)
  }

  get terraceDepth() {
    return this._terraceDepth
  }

  get frontHeight() {
    return this._frontHeight
  }

  get angleCompensation() {
    return this._angleCompensation
  }

  get height() {
    return this._height
  }

  get windowsSideTotal() {
    return this._windowsSideTotal
  }

  get windowsSideWidth() {
    return this._windowsSideWidth
  }

  get logsSideTotal() {
    return this._logsSideTotal
  }

  public updateDepth(depth: TTerraceDepth, angle: number, height: number) {
    this._terraceDepth = Model.terraceDepth(depth)
    this._frontHeight = Model.frontHeight(angle, depth, height)
    this._angleCompensation = Model.angleCompensation(angle, depth)
    this._windowsSideTotal = Model.windowsSide(depth)
    this._windowsSideWidth = Model.windowsSideWidth(
      depth,
      this.windowsSideTotal
    )
    this._logsSideTotal = Model.logsSideTotal(depth)
  }
}
